import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Numeral from 'numeral';
import _ from 'lodash';

const SellingProfile = ({ ...props }) => {
  SellingProfile.propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    referral: PropTypes.object,
    property: PropTypes.object,
    userprofile: PropTypes.object
  };

  let listPriceMin = _.get(props.opportunity, 'listPriceMin', 'No Min');
  let listPriceMax = _.get(props.opportunity, 'listPriceMax', 'No Max');

  if (!isNaN(listPriceMin)) {
    listPriceMin = `$${Numeral(listPriceMin).format('0,0')}`;
  }

  if (!isNaN(listPriceMax)) {
    listPriceMax = `$${Numeral(listPriceMax).format('0,0')}`;
  }

  // Planning to Buy
  let planningToBuy = '';

  if (props.opportunity.isPlanningToBuy === true) {
    planningToBuy = 'Planning to Buy (Yes)';
  }

  if (props.opportunity.isPlanningToBuy === false) {
    planningToBuy = 'Planning to Buy (No)';
  }

  let timeFrameLabel = (props.opportunity.timeFrameInDays || props.opportunity.timeFrameInDays === 0) ? props.opportunity.timeFrame : '';
  ((props.opportunity.timeFrameInDays || props.opportunity.timeFrameInDays === 0) && planningToBuy) ? timeFrameLabel += ` - ${planningToBuy} ` : timeFrameLabel += planningToBuy;

  const lotSizeOptions = [
    { label: 'Any', value: null },
    { label: '2,000 sq ft +', value: 2000 },
    { label: '3,000 sq ft +', value: 3000 },
    { label: '4,000 sq ft +', value: 4000 },
    { label: '6,000 sq ft +', value: 6000 },
    { label: '8,000 sq ft +', value: 8000 },
    { label: '0.25 acres', value: 10890 },
    { label: '0.5 acres', value: 21780 },
    { label: '1 acre', value: 43560 },
    { label: '2 acres', value: 87120 },
    { label: '3 acres', value: 130680 },
    { label: '5 acres', value: 217800 },
    { label: '10 acres', value: 435600 },
    { label: '20 acres +', value: 871200 }
  ];

  const lotSize = lotSizeOptions.filter((option) => {
    /* eslint-disable eqeqeq */
    return option.value == props.opportunity.lotSizeSqftMin;
    /* eslint-enable eqeqeq */
  });

  return (
    <React.Fragment>
      <div className='small-sm-down' style={{ position: 'relative' }}>
        <div className='d-flex justify-content-between mb-3'>
          <div>
            <strong>Location(s) of Interest</strong>
            <div>
              {props.opportunity.areasOfInterest
                .map((location) => {
                  return location.value;
                })
                .join(', ')
              }
            </div>
          </div>
        </div>

        <div className='mb-3'>
          <strong>Est. Price</strong>
          <div>{`${listPriceMin} - ${listPriceMax}`}</div>
        </div>

        <div className='mb-3'>
          <strong>Est. Time Frame</strong>
          <div>{timeFrameLabel}</div>
        </div>

        <div className='mb-3'>
          <strong>Property Info</strong>
          <div>
            {props.opportunity.propertyTypesOfInterest && props.opportunity.propertyTypesOfInterest.join(', ')}
          </div>
          <div>
            {(props.opportunity.bedroomsMin && `${props.opportunity.bedroomsMin} Bed`) || 'Any Bed Size'}
            {(props.opportunity.bathroomsMin && ` - ${props.opportunity.bathroomsMin} Bath`) || ' - Any Bath Size'}
            {(props.opportunity.buildingSizeSqftMin && ` - ${props.opportunity.buildingSizeSqftMin} Sq Ft`) || ' - Any Building Size'}
          </div>
          <div>
            {lotSize.length > 0 && `Lot Size: ${lotSize[0].label}; `}
            {props.opportunity.yearBuiltMin && `Year Built: ${props.opportunity.yearBuiltMin}`}
          </div>
        </div>

        <div className='text-muted'>
          {`Updated: ${moment(props.opportunity.timestampModified).format('MM/DD/YY')}`}
        </div>
      </div>
    </React.Fragment>
  );
};
export default SellingProfile;
